export default {
  es: {
    risk: 'Riesgo',
    month: 'Mes',
    names: 'Nombres',
    lastNames: 'Apellidos',
    id: 'Cédula',
    age: 'Edad',
    insuranceCarrier: 'Aseguradora',
    sgateTFG: 'Estadío por TFG Cockroft Gault sin ajuste',
    TFG: 'TFG Cockroft Gault sin ajuste',
    kidneyUnit: 'Unidad Renal',
    TFG2009: 'TFG CKD EPI 2009',
    stageTFG2009: 'Estadío TFG CKD EPI 2009',
    modality: 'Modalidad',
    therapy: 'Terapia',
    filterBy: 'Filtrar por',
    variation: 'Variación'
  },
  en: {
    risk: 'Risk',
    month: 'Month',
    names: 'Names',
    lastNames: 'Last names',
    id: 'Id',
    age: 'Age',
    insuranceCarrier: 'Insurance carrier',
    sgateTFG: 'TFG Cockroft Gault Stage no adjustment',
    TFG: 'TFG Cockroft Gault no adjustment',
    kidneyUnit: 'Kidney unit',
    TFG2009: 'TFG CKD EPI 2009',
    stageTFG2009: 'Stage TFG CKD EPI 2009',
    modality: 'Modality',
    therapy: 'Therapy',
    filterBy: 'Filter by',
    variation: 'Variation'
  }
};
